// ##### Komarov 2025-07-18
import React, { useEffect } from 'react';
// ##### 25-05-21 Komarov
import HotelsPaxChoice from '../HotelsPaxChoice/HotelsPaxChoice';
import { useDispatch } from 'react-redux';
import { setisOnModalDiv } from '../../../../../Redux/actions';

// ##### Komarov 2025-07-18
const PaxChoice = ({ transform }) => {
  const dispatch = useDispatch();
  useEffect(() => {
    dispatch(setisOnModalDiv(true));
  }, []);
  return (
    <div
      data-component="PaxChoice"
      style={{
        transform,
      }}
    >
      <HotelsPaxChoice />
    </div>
  );
};

export default PaxChoice;
